module.exports = __webpack_public_path__ + "img/employee.44911d95.png";